import { AppleItunesApp } from 'shared/components/HelmetMetaTags/components/AppleItunesApp';

export const MetaParts = {
	AppleItunesApp,
};
